import {Component, OnInit, ViewChild} from '@angular/core';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {NgForm} from '@angular/forms';
import {ApprovalClassModel} from '../../../../../components/googleClassroom/googleClassroom.model';
import {AddStudentRcModel, rciModel} from '../../../../../components/dataAnalytics/dataAnalytics.model';
import {Router} from '@angular/router';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {AppConstants} from '../../../../../app.constants';
import * as html2pdf from "html2pdf.js"
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';






@Component({
  selector: 'app-student-profile',
  templateUrl: './questions-generator.component.html',
  styleUrls: ['./questions-generator.component.css']
})

export class QuestionsGeneratorComponent implements OnInit {
  @ViewChild('form') form : NgForm;
  selectedFile: File;
  selectStyle: string;
  public previwbtn: boolean = true;
  public printbtn: boolean = false;
  approvalClassModel = new ApprovalClassModel();
  addStudentRcModel = new AddStudentRcModel();
  rcimodel = new rciModel()
  // public data1: AddStudentRcModel[];
  public ReportsData: any = [];
  googleUser: any;
  studentList = [];
  courseId: any;
  selectedGrade: any;
  selectedSection: any = [];
  sectionList: any = [];
  public newSectionArray = [];
  studentData: any = [];
  studentRCData: any = [];
  sumamryTable: any = [];
  public userdetailes = [];
  confirmFlag: boolean = true;
  thresholdText: number;
  selectedGCl: any;
  gclList: any;
  selectedDate: any;
  searchFlag: boolean = false;
  studentThresholdList: any = [];
  standardId: any = [];
  nameofstd: any = [];
  nameofsec: any = [];
  yearIdFrom: any = [];
  yearName: any = [];
  yearnameFrom: any = [];
  yearIdTo: any = [];
  yearnameTo: any = [];
  nameofstudent: any = [];
  nameofsem: any = [];
  nameoftest: any = [];
  loading = "none"
  ChildTestMappingId: string;
  students: any = [];
  SemesterData: any = [];
  YearData: any = [];
  TestData: any = [];
  SchoolDetailsaddress : any =[];
  NumberOfStudents: any = [];
  studentId: any = [];
  testId: any = [];
  sectionId: any = []
  guru: any = [];
  payload: any = [];
  public isEditable : Boolean = true;
  Marks: any = [];
  MaxMarks: any = [];
  today = new Date();
  Averages: any;
  schoolName :any;

  subjectsList: any = [];
  teacherValidateSubjectsList: any = [];
  selectedSubject: any;
  selectedYearFrom: any;
  selectedYearTo: any;
  selectedSemester: any;
  selectedTest: any;

  paperName: any;
  paperGrade: any;

  lessQuestions: boolean = false;

  public isSuccessful: number = 0;
  public successOrErrorMsg: string = "";

  public grade: any = [];
  public selectedgrade:  any;
  public selectedsection:  any;

  public CurrentChild: any;
  public schoolLogo1 :string;
  public imgUrl1: string;
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public mappedData: any;
  public attachment;
  public Address: any;
  public City : any;
  public Pincode : any;
  public PrimaryPhonenumber : any;
  public WebsiteLink : any;
  public Email : any;
  public Logo : any;
  public RegNo :any;
  public userId :string;
  public childMapId : any = [];
  public TeacherNames : any = [];
  public EncodedLogo : any;
  public ShowLevelData: any;
  public selectedlevel: any;

  public convertContentOne: any;
  public convertContentTwo: any;

  public convertContentedOne: any;
  public convertContentedSyllabus: any;
  public convertContentedTwo: any;
  public convertGrade: any;
  public convertSubject: any;
  public convertNoOfQuestions: any;


  public papersList: any = [];
  public syllabusList: any = [];
  public agg_question_list: any = [];
  public agg_syllabus_list: any = [];
  public generatedQuestions: any = [];
  public mcqQuestions: any = [];
  public contextQuestions: any = [];
  public imageQuestions: any = [];
  public mcqQuestionsS: any = [];

  public contextQuestionsS: any = [];

  questionCounts = [5, 10, 15, 20];
  questionLanguage = [
    {name: 'English', id: 1},
    {name: 'Sinhala', id: 2},
    {name: 'Tamil', id: 3}


  ];
  selectedQuestionCount: number;
  selectedLanguage: number;
  translateLanguage: number;

  mcq: boolean = true;
  discussion: boolean = false;
  shortAnswer: boolean = false;
  imgQuestion: boolean = false;

  isLoading: boolean = false;

  useSyllabus: boolean = false;

  editDiagramDialog = false;
  diagramDescription = '';
  editedImage = '';
  editImgPayload: any;
  editImgIndex: any;

  showSaveDialog = false;
  showTranslateDialog = false;
  pdfName = 'question_paper';
  wordName = 'question_paper';


  public contextQ: any = [];
  public mcqQ: any = [];
  errorMessage: string = '';
  displayErrorDialog: boolean = false;



  constructor(private dataAnalyticsService: DataAnalyticsService,
              private router: Router,
              private noticeboardService: NoticeboardService,
              private appConstants: AppConstants,
              private sanitizer: DomSanitizer,
              private localStorage: LocalStorageService,
              private messageService: MessageService) {

    // this.schoolName = this.localStorage.retrieve('schoolname');
    this.schoolLogo1 = this.localStorage.retrieve('Logo');
    this.userId = this.localStorage.retrieve('id');
    this.imgUrl1 = this.appConstants.fileDownloadUrl;
    // this.attachment = this.imgUrl1 + this.Logo;
    this.userId = this.localStorage.retrieve('id');


  }

  ngOnInit() {
    this.getLevelsName();
    this.getYearData();
    //----------------------------------
    this.adminUserFlag = this.localStorage.retrieve('IsSchoolAdminUser');
    this.schoolUserFlag = this.localStorage.retrieve('Isschooluser');
    // this.selectedQuestionCount = this.questionCounts[0];
  }

  getSubjects(){
    this.dataAnalyticsService.getSubjects(this.selectedSection.SectionId).finally(() => { }).subscribe(
      response => {
        let res: any = response;
        this.subjectsList = res.subsemList[0];

        const filteredSubjects = this.subjectsList.filter(subject =>
          this.teacherValidateSubjectsList.some(teacherSubject => teacherSubject.SubjectId === subject.SubjectId)
        );

        this.subjectsList = filteredSubjects;

        console.log('sub sub',this.subjectsList);

        try {
          // this.selectedSubject = this.subjectsList[0];
          // console.log(this.selectedSubject);
          // if (this.useSyllabus){
          //   this.getSyllabusData();
          //
          // }else{
          //   this.getPaperData();
          // }
        } catch (error) {

        }
      },
      error => {
        console.log("getSubjects error", error);
        this.subjectsList = [];
      });
  }


  getTeacherValidatedSubjects(academicYearId: any, userId: any){
    this.dataAnalyticsService.getTeacherValidateSubjects(academicYearId,userId).finally(() => { }).subscribe(
      response => {
        let res: any = response['Value'];
        this.teacherValidateSubjectsList = res;
        console.log(this.teacherValidateSubjectsList);
      },
      error => {
        console.log("getSubjects error", error);
      });
  }


  toggleSelection() {
    this.useSyllabus = !this.useSyllabus;
    // console.log(this.useSyllabus);
    // if (this.useSyllabus){
    //   this.getSyllabusData();
    //
    // }else{
    //   this.getPaperData();
    // }
  }



  onSelectedSubject(subject){
    this.papersList = [];
    this.syllabusList = [];
    this.agg_syllabus_list = [];
    this.agg_question_list = [];
    this.contextQuestions = [];
    this.mcqQuestions = [];
    this.contextQuestionsS = [];
    this.mcqQuestionsS = [];
    this.imageQuestions = [];
    this.convertContentOne = '';
    this.convertContentTwo = '';
    this.convertContentedSyllabus = '';
    this.convertContentedOne = '';
    this.convertContentedTwo = '';
    this.convertGrade = '';
    this.convertSubject = '';
    this.lessQuestions = false;
    // console.log(payload);
    // if (this.useSyllabus){
    //   this.getSyllabusData();
    //
    // }else{
    //   this.getPaperData();
    // }
  }


  // manage-user data
  public get_userdetailes() {
    var id = this.localStorage.retrieve('Id');
    this.noticeboardService.getUserdetailbyId(id).subscribe(response => {
      this.userdetailes = response['selectedSbAccessPermission'];
      const isAdmin = this.userdetailes.some(u => u.Rank == 1);

      let result = this.mappedData.filter(m =>
        this.userdetailes.some(u => u.standardid === m.standardId && (u.Rank == 2 || u.Rank == 3)
        ));
      const sectionsResult = this.mappedData.filter(m => (
        this.userdetailes.some(u => !result.some(r => r.standardId === u.standardid) && u.Rank == 4 && m.Sections.some(s => s.SectionId === u.sectionid))
      )).map(m => ({
        ...m,
        Sections: m.Sections.filter(s => this.userdetailes.some(u => u.sectionid === s.SectionId))
      }));
      result = result.concat(sectionsResult);
      this.newSectionArray = result;
      // console.log(this.mappedData);
      console.log(result, 'result');
    })
  }


  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          // this.selectedGrade = mappedData[mappedData.length - 1];
          // this.getSectionByGrade(this.selectedGrade);
          // this.selectedSection = this.selectedGrade.Sections[0];
          // this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        this.students = [];
        this.NumberOfStudents = [];
        this.SemesterData = [];
        this.TestData = [];
        this.studentRCData = [];
        try {
          this.nameofsec = this.selectedSection.sectionName;
          this.sectionId = this.selectedSection.SectionId;
        } catch (error) {

        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /*else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }*/
      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedGrade = null;
        this.selectedSection = null;
        this.selectedSubject = null;
      });
  };



  private getLevelClassSectionNew() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;
        }
        // console.log(this.teacherValidateSubjectsList);
        //
        // const filteredGrades = mappedData.filter(grade =>
        //   this.teacherValidateSubjectsList.some(subject => subject.GradeId === grade.standardId)
        // );

        // console.log(filteredGrades);
        // this.mappedData = filteredGrades;

        try {
          // this.selectedGrade = mappedData[mappedData.length - 1];
          // this.getSectionByGrade(this.selectedGrade);
          // this.selectedSection = this.selectedGrade.Sections[0];
          // this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        this.students = [];
        this.NumberOfStudents = [];
        this.SemesterData = [];
        this.TestData = [];
        this.studentRCData = [];
        try {
          this.nameofsec = this.selectedSection.sectionName;
          this.sectionId = this.selectedSection.SectionId;
        } catch (error) {

        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /*else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }*/
      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedGrade = null;
        this.selectedSection = null;
        this.selectedSubject = null;
      });
  };


  private getClassSection() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (this.adminUserFlag) {
          this.mappedData = mappedData;
          // this.priorityFlag = true;
        }
        else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }
      },
      error => {
      });
  };


  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.papersList = [];
    this.agg_syllabus_list = [];
    this.agg_question_list = [];
    this.syllabusList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    this.sectionList.sort((a, b) => {
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    try {
      this.selectedSection = this.sectionList[0];
      this.getSubjects();
    } catch (error) {

    }
  }


  getGclClassesListById(section) {
    this.students = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    this.nameofstudent = [];
    //this.getStudentData(this.standardId,section.SectionId,this.yearId)
    console.log('getGclClassesListById', section);
    this.getSubjects();
  }
  // (minutes >= 1 && minutes <= 15)



  getYearListFrom(year) {
    this.yearIdFrom = year.YearId;
    this.yearnameFrom = year.AcademicYear;
    // if (this.yearIdFrom && this.yearIdTo && this.selectedGrade.standardId && this.selectedSubject.SubjectId) {
    //   if (this.useSyllabus){
    //     this.getSyllabusData();
    //
    //   }else{
    //     this.getPaperData();
    //   }
    // }

    // console.log(this.yearnameFrom)
    // console.log(this.yearIdFrom)
  }


  getYearListTo(year) {
    // console.log(year)
    this.yearIdTo = year.YearId;
    this.yearnameTo = year.AcademicYear;
    this.yearIdFrom = year.YearId;
    this.yearnameFrom = year.AcademicYear;
    this.mappedData = [];
    this.subjectsList = [];
    this.getLevelClassSectionNew();
    this.getTeacherValidatedSubjects(this.yearIdTo,this.userId);
    // if (this.yearIdFrom && this.yearIdTo && this.selectedGrade.standardId && this.selectedSubject.SubjectId) {
    //   if (this.useSyllabus){
    //     this.getSyllabusData();
    //
    //   }else{
    //     this.getPaperData();
    //   }
    // }
  }

  //
  // private getSemesterData() {
  //   this.dataAnalyticsService.getSemester(this.yearId)._finally(() => { }).subscribe(
  //     response => {
  //       this.SemesterData = response['semestersList'];
  //       console.log("Semesters",this.SemesterData )
  //       // console.log("academicYearId", academicYearId )
  //
  //       try {
  //         this.selectedSemester = this.SemesterData[0];
  //         this.getTestData(this.selectedSemester.SemesterId);
  //       } catch (error) {
  //
  //       }
  //     }
  //   )
  // }
  //


  ////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////

  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        // console.log(this.YearData);
        // this.yearIdFrom = this.YearData[0].YearId;
        // this.yearName = this.YearData[0].;
        // this.yearIdTo = this.YearData[0].YearId;
        // console.log(this.yearIdFrom);
        try {
          // this.selectedYearFrom = this.YearData[0];
          // this.selectedYearTo = this.YearData[0];
        } catch (error) {

        }

        // console.log(response )
      }
    )
  }


  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          // this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          // this.getLevelClassSection(this.selectedlevel);

        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
      }, (error) => {

      });
  }

  getLevelsListById(){
    this.papersList = [];
    this.syllabusList = [];
    this.agg_syllabus_list = [];
    this.agg_question_list = [];
    this.getLevelClassSection(this.selectedlevel);
    // if (this.yearIdFrom && this.yearIdTo && this.selectedGrade.standardId && this.selectedSubject.SubjectId) {
    //   if (this.useSyllabus){
    //     this.getSyllabusData();
    //
    //   }else{
    //     this.getPaperData();
    //   }
    // }
  }

////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////
  private GetGrade(){
    this.dataAnalyticsService.getGradeLevel(this.selectedlevel).finally(() => { }).subscribe(
      response => {
        this.grade = response;
        try {
          this.selectedgrade =  this.grade[0].standardId;
        } catch (error) {
        }
        console.log('grade',this.grade)
      },
      error => {
        this.grade = [];
        console.error(error);
        console.log('grade',this.grade)
      });
  };

  changegrade() {
    console.log(this.selectedgrade)

  };
  changesection(){
    console.log(this.selectedsection)
  }

////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////
  queryInput: any;

  onSelectedQuestionCount(value: number) {
    console.log('Selected Question Count:', value);
    // Additional logic here
  }

  toggleMcq(event: any) {
    if (event.target.checked) {
      this.mcq = true;
      this.imgQuestion = false;
    } else {
      // Remove the subject from the array if it's unchecked
      this.mcq = false;
    }
    console.log('mcq',this.mcq);
  }


  toggleDiscussion(event: any) {
    if (event.target.checked) {
      this.discussion = true;
    } else {
      // Remove the subject from the array if it's unchecked
      this.discussion = false;
    }
    console.log('discussion',this.discussion);
  }


  toggleShortAnswer(event: any) {
    if (event.target.checked) {
      this.shortAnswer = true;
      this.imgQuestion = false;
    } else {
      // Remove the subject from the array if it's unchecked
      this.shortAnswer = false;
    }
    console.log('short answer',this.shortAnswer);
  }

  toggleImageQuestion(event: any) {
    if (event.target.checked) {
      this.mcq = false;
      this.shortAnswer = false;
      this.imgQuestion = true;
    } else {
      // Remove the subject from the array if it's unchecked
      this.imgQuestion = false;
    }
    console.log('short answer',this.imgQuestion);
  }


  generate() {
    this.contextQuestions = [];
    this.mcqQuestions = [];
    this.contextQuestionsS = [];
    this.mcqQuestionsS = [];
    this.imageQuestions = [];
    this.convertContentOne = '';
    this.convertContentTwo = '';
    this.convertContentedSyllabus = '';
    this.convertContentedOne = '';
    this.convertContentedTwo = '';
    this.convertGrade = '';
    this.convertSubject = '';
    this.lessQuestions = false;
    if (this.useSyllabus) {
      let payload: any = {
        gradeid: this.selectedGrade.standardId,
        subid: this.selectedSubject.SubjectId,
        NumberOfQuestions: this.selectedQuestionCount,
        language: this.selectedLanguage,
      };
      this.isLoading = true;
      this.dataAnalyticsService.generatePaperBySyllabusCcodeNew(payload).subscribe({
        next: (response) => {
          console.log(response);
          const questionsText = response['Questions'].trim();

          this.convertContentedSyllabus = questionsText;

          if (questionsText && typeof questionsText === 'string') {
            try {
              const parsed = JSON.parse(questionsText);
              const contextArray = parsed.Context;

              if (Array.isArray(contextArray)) {
                this.contextQuestionsS = contextArray.map(item => ({
                  context: item.context,
                  questions: item.questions
                }));
              } else {
                console.warn("Parsed Context is not an array.");
                this.contextQuestionsS = [];
              }

              console.log("Formatted Questions Structure:", this.contextQuestionsS);

            } catch (err) {
              console.error("Failed to parse Questions JSON:", err);
              this.contextQuestionsS = [];
            }
          } else {
            console.warn("Questions field missing or not a string.");
            this.contextQuestionsS = [];
          }
          this.convertGrade = this.selectedGrade.standardId;
          this.convertSubject = this.selectedSubject.SubjectId;
          this.convertNoOfQuestions = this.selectedQuestionCount;
          this.isLoading = false;
          this.paperName = this.selectedGrade.standardsName;
          this.paperGrade = this.selectedSubject.SubjectName;
          this.isLoading = false;
          this.selectedYearFrom = '';
          this.selectedYearTo = '';
          this.selectedlevel = '';
          this.selectedGrade = '';
          this.selectedSubject = '';
        },
        error: (error) => {
          console.error(error);
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Question generation failed"
          });
          this.isLoading = false;
        }
      });
    } else {
      console.log('no syllabus');
      // this.getPaperData();
      if(!this.mcq && !this.shortAnswer){
        let payload: any = {
          agg_question_list: this.agg_question_list,
          no_questions: this.selectedQuestionCount,
          language: this.selectedLanguage,
          mcq: this.mcq ? "True" : "False", // Convert boolean to string
          short: this.shortAnswer ? "True" : "False", // Convert boolean to string
          image_generation: this.imgQuestion ? "True" : "False",
          subject: this.selectedSubject.SubjectName,
          subjectId: this.selectedSubject.SubjectId,
          academicYearFromId: this.yearIdFrom,
          academicYearToId: this.yearIdTo,
          gradeid: this.selectedGrade.standardId,
          user_special_query: this.queryInput,
        };

        let payloadMcq: any = {
          "Id": 0,
          "PromptTypeName": "MCQ",
          "PromptContent": "string"
        }
        let payloadContext : any = {
          "Id": 0,
          "PromptTypeName": "Context",
          "PromptContent": "string"
        }
        let payloadImage : any = {
          "Id": 0,
          "PromptTypeName": "Image",
          "PromptContent": "string"
        }


        let payloadArray = [];

        if (this.mcq) {
          payloadArray.push(payloadMcq);
        }

        if (this.shortAnswer) {
          payloadArray.push(payloadContext);
        }

        if (this.imgQuestion) {
          payloadArray.push(payloadImage);
        }
        const apiCode = 'VSoK9Ip_yY3TdbG5Z1KkYoLAmkelybWP4tcuwxy4BFgLAzFuq5I54Q==';

        const timeoutId = setTimeout(() => {
          this.isLoading = false;
          this.messageService.add({
            severity: "error",
            summary: "Timeout",
            detail: "Sorry, please try again"
          });
        }, 600000); // 1 minute timeout
        this.isLoading = true;
        this.dataAnalyticsService.generatePaperByPapersCcode(payloadArray,
          this.yearIdFrom,
          this.selectedGrade.standardId,
          this.selectedSubject.SubjectId,
          this.selectedQuestionCount,
          this.selectedLanguage).subscribe({
          next: (response) => {
            console.log(response['Results']);
            // this.convertContent = response['Results'];

            try {
              // Step 1: Validate the response structure
              if (!response || !Array.isArray(response['Results'])) {
                throw new Error('Invalid response format: Results is not an array.');
              }
              // Step 2: Get the raw JSON string from Results[0]
              const rawJsonString = response['Results'][0];
              if (typeof rawJsonString !== 'string') {
                throw new Error(`Results[0] is not a string. Found type: ${typeof rawJsonString}`);
              }
              // Step 3: Clean the JSON string (remove markdown syntax)
              const cleanedJsonString = rawJsonString
                .replace(/```json/g, '') // Remove opening ```json
                .replace(/```/g, '') // Remove closing ```
                .trim();
              // console.log('Cleaned JSON String:', cleanedJsonString);

              // Step 4: Parse the cleaned JSON string
              const parsedJson = JSON.parse(cleanedJsonString);
              this.convertGrade = this.selectedGrade.standardId;
              this.convertSubject = this.selectedSubject.SubjectId;
              this.convertNoOfQuestions = this.selectedQuestionCount;

              const imageArray = parsedJson.Image;

              if (Array.isArray(imageArray)) {
                this.imageQuestions = imageArray.map(context => ({
                  ...context,
                  questions_with_image: Array.isArray(context.questions_with_image)
                    ? context.questions_with_image.map(question => ({
                      ...question,
                      image: question.image
                        ? question.image.replace(/^"|"$/g, '').replace(/"/g, "'") // Clean image URL
                        : ''
                    }))
                    : [] // Ensure it's an array to avoid undefined errors
                }));
              } else {
                console.error('Invalid data structure: Image array is missing or malformed.');
              }
              this.imageQuestions = this.imageQuestions.map(item => {
                return {
                  context: item.context,
                  image: item.questions_with_image[0].image || "", // Extract image from the first question
                  questions: item.questions_with_image
                    .filter(q => q.question) // Keep only objects with questions
                    .map(q => ({ question: q.question }))
                };
              });

              console.log(this.imageQuestions);
            } catch (error) {
              console.error('Error:', error.message, error);
            }


            clearTimeout(timeoutId); // Clear the timeout on successful response

            this.paperName = this.selectedGrade.standardsName;
            this.paperGrade = this.selectedSubject.SubjectName;
            this.isLoading = false;
            this.selectedYearFrom = '';
            this.selectedYearTo = '';
            this.selectedlevel = '';
            this.selectedGrade = '';
            this.selectedSubject = '';
            payloadArray = [];
            if (this.imgQuestion) {
              if ((this.imageQuestions.length < this.selectedQuestionCount)){
                this.lessQuestions = true;
              }
            }
          },
          error: (error) => {
            console.error(error);
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Question generation failed"
            });
            this.isLoading = false;
          }
        });
      }else {
        let payload: any = {
          agg_question_list: this.agg_question_list,
          no_questions: this.selectedQuestionCount,
          language: this.selectedLanguage,
          mcq: this.mcq ? "True" : "False", // Convert boolean to string
          short: this.shortAnswer ? "True" : "False", // Convert boolean to string
          image_generation: this.imgQuestion ? "True" : "False", // Convert boolean to string
          subject: this.selectedSubject.SubjectName,
          subjectId: this.selectedSubject.SubjectId,
          academicYearFromId: this.yearIdFrom,
          academicYearToId: this.yearIdTo,
          gradeid: this.selectedGrade.standardId,
          user_special_query: this.queryInput,
        };

        let payloadMcq: any = {
          "Id": 0,
          "PromptTypeName": "MCQ",
          "PromptContent": "string"
        }
        let payloadContext : any = {
          "Id": 0,
          "PromptTypeName": "Context",
          "PromptContent": "string"
        }
        let payloadImage : any = {
          "Id": 0,
          "PromptTypeName": "Image",
          "PromptContent": "string"
        }


        let payloadArray = [];

        if (this.mcq) {
          payloadArray.push(payloadMcq);
        }

        if (this.shortAnswer) {
          payloadArray.push(payloadContext);
        }

        if (this.imgQuestion) {
          payloadArray.push(payloadImage);
        }

        console.log(this.mcq);
        console.log(this.shortAnswer);
        console.log(this.imgQuestion);
        console.log(payloadArray);
        const apiCode = 'VSoK9Ip_yY3TdbG5Z1KkYoLAmkelybWP4tcuwxy4BFgLAzFuq5I54Q==';

        const timeoutId = setTimeout(() => {
          this.isLoading = false;
          this.messageService.add({
            severity: "error",
            summary: "Timeout",
            detail: "Sorry, please try again"
          });
        }, 600000); // 1 minute timeout
        this.isLoading = true;
        this.dataAnalyticsService.generatePaperByPapersCcode(payloadArray,
          this.yearIdFrom,
          this.selectedGrade.standardId,
          this.selectedSubject.SubjectId,
          this.selectedQuestionCount,
          this.selectedLanguage).subscribe({
          next: (response) => {
            console.log(response);

            // Step 1: Safely access the elements in the response['Results'] array
            const rawStringOne = response['Results'][0] || null;
            const rawStringTwo = response['Results'][1] || null;

            this.convertContentOne = rawStringOne;
            this.convertContentTwo = rawStringTwo;

            // Step 2: Initialize the cleaned strings
            let cleanedStringOne = null;
            let cleanedStringTwo = null;

            // Step 3: Clean the strings if they exist
            if (rawStringOne) {
              cleanedStringOne = rawStringOne.replace(/```json|```/g, '').trim();
            }
            if (rawStringTwo) {
              cleanedStringTwo = rawStringTwo.replace(/```json|```/g, '').trim();
            }

            this.convertGrade = this.selectedGrade.standardId;
            this.convertSubject = this.selectedSubject.SubjectId;

            // Step 4: Parse the cleaned strings into JSON objects if they are not null
            let parsedObjectOne = null;
            let parsedObjectTwo = null;

            if (cleanedStringOne) {
              parsedObjectOne = JSON.parse(cleanedStringOne);
            }
            if (cleanedStringTwo) {
              parsedObjectTwo = JSON.parse(cleanedStringTwo);
            }

            if (parsedObjectOne) {
              if (parsedObjectOne.MCQ) {
                this.mcqQuestions = parsedObjectOne.MCQ;
              }
              if (parsedObjectOne.Context) {
                this.contextQuestions = parsedObjectOne.Context;
              }
            }

            if (parsedObjectTwo) {
              if (parsedObjectTwo.MCQ) {
                this.mcqQuestions = parsedObjectTwo.MCQ;
              }
              if (parsedObjectTwo.Context) {
                this.contextQuestions = parsedObjectTwo.Context;
              }
            }

            console.log(this.mcqQuestions);
            console.log(this.contextQuestions);


            clearTimeout(timeoutId); // Clear the timeout on successful response


            this.paperName = this.selectedGrade.standardsName;
            this.paperGrade = this.selectedSubject.SubjectName;

            this.isLoading = false;
            this.selectedYearFrom = '';
            this.selectedYearTo = '';
            this.selectedlevel = '';
            this.selectedGrade = '';
            this.selectedSubject = '';
            payloadArray = [];
            if (this.mcq && this.shortAnswer) {
              if ((this.contextQuestions.length < this.selectedQuestionCount) || (this.mcqQuestions < this.selectedQuestionCount)){
                this.lessQuestions = true;
              }
            }else if (this.mcq){
              if (this.mcqQuestions.length < this.selectedQuestionCount){
                this.lessQuestions = true;
              }
            }else if (this.shortAnswer){
              if (this.contextQuestions.length < this.selectedQuestionCount){
                this.lessQuestions = true;
              }
            }else{
              this.lessQuestions = false;
            }
          },
          error: (error) => {
            console.error(error);
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Question generation failed"
            });
            this.isLoading = false;
          }
        });
      }
    }
    // this.isLoading = false;
  }



  getSanitizedSVG(image: string) {
    return this.sanitizer.bypassSecurityTrustHtml(image);
  }

  showErrorDialog(message: string) {
    this.errorMessage = message;
    this.displayErrorDialog = true;
    this.isLoading = false;
    this.isSuccessful = 2;
  }

  private getPaperData() {
    this.isLoading = true; // Start loading
    this.dataAnalyticsService.getPaper(this.yearIdFrom,this.yearIdTo,this.selectedGrade.standardId,this.selectedSubject.SubjectId)._finally(() => {
      this.isLoading = false; // Stop loading
    }).subscribe(
      response => {
        console.log(response);
        this.papersList = response['Values'];
        // Mapping the response to a new array containing only the specified properties
        this.agg_question_list = this.papersList.map(item => ({
          question_list: JSON.parse(item.Content),
          year: item.AcademicYearName,
          grade: item.GradeName,
          source: item.PaperName,
          Term: item.SemesterName,
          subject_type: item.SubjectName,
        }));

        console.log(this.agg_question_list);
      },
      error => {
        this.isLoading = false; // Start loading
        console.error(error);
        this.showErrorDialog("No uploaded papers to refer");
      }
    )
  }





  private getSyllabusData() {
    this.isLoading = true; // Start loading
    this.dataAnalyticsService.getSyllabusGenerate(this.yearIdFrom,this.yearIdTo,this.selectedGrade.standardId,this.selectedSubject.SubjectId)._finally(() => {
      this.isLoading = false; // Stop loading
    }).subscribe(
      response => {
        console.log(response);
        this.syllabusList = response['Values'];
        // Mapping the response to a new array containing only the specified properties
        this.agg_syllabus_list = this.syllabusList.map(item => ({
          syllabus_list: JSON.parse(item.Content),
          year: item.AcademicYearName,
          grade: item.GradeName,
          source: item.PaperName,
          Term: item.SemesterName,
          subject_type: item.SubjectName,
        }));

        console.log(this.agg_syllabus_list);
      },
      error => {
        this.isLoading = false; // Start loading
        console.error(error);
        this.showErrorDialog("No uploaded papers to refer");
      }
    )
  }






  PrintPdf() {

    const options = {
      filename: (this.paperGrade && this.paperName)
        ? `${this.paperGrade}_${this.paperName}`
        : 'question_paper',      margin: [15, 0, 15, 0],
      image: { type: 'jpeg', quality: 1 },
      // html2canvas : {},
      layout: 'noBorders',
      html2canvas: {
        dpi: 192,
        scale: 4,
        letterRendering: true,
        useCORS: true,
        // allowTaint : true
      },
      jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4', compressPDF: false }
    };

    const content: Element = document.getElementById('asdf')

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }


  PrintPdff() {

    const options = {
      filename: this.paperGrade+'_'+this.paperName,
      margin: [15, 0, 15, 0],
      image: { type: 'jpeg', quality: 1 },
      // html2canvas : {},
      layout: 'noBorders',
      html2canvas: {
        dpi: 192,
        scale: 4,
        letterRendering: true,
        useCORS: true,
        // allowTaint : true
      },
      jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4', compressPDF: false }
    };

    const content: Element = document.getElementById('asdff')

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }













  savePdf() {
    this.isLoading = true;
    // this.showSaveDialog = true;
    if (this.pdfName) {
      // Add your PDF saving logic here
     let questions: any;
      // console.log(this.contextQuestionsS);
      // console.log(this.mcqQuestionsS);
      // console.log(this.contextQuestions);
      // console.log(this.mcqQuestions);

      if (this.useSyllabus){
        questions = {
          'contextQuestions': this.contextQuestionsS,
          'mcqQuestions': this.mcqQuestionsS,
        }
      }else{
        questions = {
          'contextQuestions': this.contextQuestions,
          'mcqQuestions': this.mcqQuestions,
        }
      }

      console.log(questions);
      console.log(this.useSyllabus);

      const contentJSONString = JSON.stringify(questions);

      let payload: any = {
        PaperName: this.pdfName,
        AcademicYearFromId: this.yearIdFrom,
        AcademicYearToId: this.yearIdTo,
        GradeId: this.convertGrade,
        SubjectId: this.convertSubject,
        SemesterId: 0,
        ExamId: 0,
        UploadedBy: '',
        Content: contentJSONString,
        PDFContent: '',
      };
      console.log(payload);
      this.dataAnalyticsService.UploadGeneratedPapers(payload).finally(() => {
      }).subscribe(
        response => {
          let res: any = response;
          console.log("upload", res);
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "PDF File uploaded successfully",
          });
          this.showSaveDialog = false;
          this.isLoading = false;
        },
        error => {
          console.log("UploadCSVFile error", error);
          this.messageService.add({
            severity: "error",
            summary: "Talkative Parents",
            detail: "Paper saving failed",
          });
          this.showSaveDialog = false;
          this.isLoading = false;
        });
      this.showSaveDialog = false;
      this.pdfName = ''; // Reset the name
    }
  }


  saveWord() {
    this.isLoading = true;

    if (this.wordName) {
      let questions: any = {
        contextQuestions: this.contextQuestionsS, // always structured now
        mcqQuestions: this.useSyllabus ? this.mcqQuestionsS : this.mcqQuestions,
        imageQuestion: !this.useSyllabus ? this.imageQuestions : [],
      };

      console.log(questions);

      let fileContent = `Paper Name: ${this.wordName}\n\nQuestions:\n\n`;

      // Context Questions
      if (questions.contextQuestions.length > 0) {
        fileContent += `Context-Based Questions:\n\n`;

        questions.contextQuestions.forEach((q: any, index: number) => {
          fileContent += `${index + 1}. ${q.context}\n`;
          q.questions.forEach((subQ: string, subIndex: number) => {
            fileContent += `   ${index + 1}.${subIndex + 1}) ${subQ}\n`;
          });
          fileContent += `\n`;
        });
      }

      // MCQ Questions
      if (questions.mcqQuestions.length > 0) {
        fileContent += `Multiple-Choice Questions:\n\n`;

        questions.mcqQuestions.forEach((q: any, index: number) => {
          fileContent += `${index + 1}. ${q.context}\n`;
          q.answers.forEach((answer: string, ansIndex: number) => {
            fileContent += `   ${String.fromCharCode(65 + ansIndex)}. ${answer}\n`;
          });
          fileContent += `\n`;
        });
      }

      // Image Questions (if present and not from syllabus)
      if (!this.useSyllabus && questions.imageQuestion.length > 0) {
        fileContent += `Image-Based Questions:\n\n`;
        questions.imageQuestion.forEach((q: any, index: number) => {
          fileContent += `${index + 1}. ${q.questionText}\n`;
          fileContent += `   [Image URL or Data: ${q.image}]\n\n`;
        });
      }

      // Create and download Word file
      const blob = new Blob([fileContent], {
        type: "application/msword",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${this.wordName}.doc`;
      link.click();

      this.messageService.add({
        severity: "success",
        summary: "Talkative Parents",
        detail: "Word file downloaded successfully",
      });

      this.wordName = "";
      this.isLoading = false;
    } else {
      this.messageService.add({
        severity: "error",
        summary: "Talkative Parents",
        detail: "Word file name is required",
      });
      this.isLoading = false;
    }
  }






  generateAnswers() {
    this.isLoading = true;
    if (this.convertContentOne) {
      const payload = {
        QuetionContent : this.convertContentOne,
        SubjectId : this.convertSubject,
        Lang : this.translateLanguage
      }
      this.dataAnalyticsService.translateLanguage(payload
      ).subscribe({
        next: (response) => {
          // Step 1: Safely access the elements in the response['Results'] array
          const rawStringOne = response['Results'][0] || null;

          // Step 2: Initialize the cleaned strings
          let cleanedStringOne = null;

          // Step 3: Clean the strings if they exist
          if (rawStringOne) {
            cleanedStringOne = rawStringOne.replace(/```json|```/g, '').trim();
          }

          // Step 4: Parse the cleaned strings into JSON objects if they are not null
          let parsedObjectOne = null;

          if (cleanedStringOne) {
            parsedObjectOne = JSON.parse(cleanedStringOne);
          }

          if (parsedObjectOne) {
            if (parsedObjectOne.MCQ) {
              this.convertContentedOne = parsedObjectOne.MCQ;
            }
          }
          console.log(this.convertContentedOne);
          if (this.convertContentTwo) {
            const payload = {
              QuetionContent : this.convertContentTwo,
              SubjectId : this.convertSubject,
              Lang : this.translateLanguage
            }
            this.dataAnalyticsService.translateLanguage(payload
            ).subscribe({
              next: (response) => {
                // Step 1: Safely access the elements in the response['Results'] array
                const rawStringTwo = response['Results'][0] || null;

                // Step 2: Initialize the cleaned strings
                let cleanedStringTwo = null;

                // Step 3: Clean the strings if they exist
                if (rawStringTwo) {
                  cleanedStringTwo = rawStringTwo.replace(/```json|```/g, '').trim();
                }

                // Step 4: Parse the cleaned strings into JSON objects if they are not null
                let parsedObjectTwo = null;

                if (cleanedStringTwo) {
                  parsedObjectTwo = JSON.parse(cleanedStringTwo);
                }

                if (parsedObjectOne) {
                  if (parsedObjectTwo.Context) {
                    this.convertContentedTwo = parsedObjectTwo.Context;
                  }
                }
                console.log(this.convertContentedTwo);
                this.showTranslateDialog = true;
                this.isLoading = false;
              },
              error: (error) => {
                console.error("Error occurred:", error);
              }
            });
          }else{
            this.showTranslateDialog = true;
            this.isLoading = false;
          }
        },
        error: (error) => {
          console.error("Error occurred:", error);
        }
      });
    }else if (this.convertContentedSyllabus) {
      console.log("Converting syllabus content...");

      let parsedQuestions: any = null;

      try {
        parsedQuestions = JSON.parse(this.convertContentedSyllabus); // this is the raw JSON string from API
      } catch (err) {
        console.error("Failed to parse initial syllabus content:", err);
        this.isLoading = false;
        return;
      }

      const payload = {
        QuetionContent: JSON.stringify({ Questions: parsedQuestions }), // send as parsed object
        SubjectId: this.convertSubject,
        Lang: this.translateLanguage,
      };

      this.dataAnalyticsService.translateLanguage(payload).subscribe({
        next: (response) => {
          const rawString = response['Results'][0] || null;
          let cleanedString = rawString ? rawString.replace(/```json|```/g, '').trim() : null;
          let parsedObject: any = null;

          if (cleanedString) {
            try {
              parsedObject = JSON.parse(cleanedString);
            } catch (err) {
              console.error("Failed to parse translated content:", err);
              this.isLoading = false;
              return;
            }
          }

          if (parsedObject.Questions.Context) {
            this.convertContentedSyllabus = parsedObject.Questions; // (optional: keep full object)
            this.contextQuestionsS = parsedObject.Questions.Context; // ✅ fix: extract only array
          }


          console.log(this.contextQuestionsS);
          this.showTranslateDialog = true;
          this.isLoading = false;
        },
        error: (error) => {
          console.error("Error occurred while translating syllabus content:", error);
          this.isLoading = false;
        },
      });
    }


  }



  // In your component.ts
  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  close() {
    this.diagramDescription = '';
    this.editImgIndex = null;
    this.editedImage = '';
    this.showSaveDialog = false;
    this.showTranslateDialog = false;
    this.editDiagramDialog = false;
  }

    save() {
      this.showSaveDialog = true;
      console.log(this.showSaveDialog);
    }


  editDiagram(item: any, index:any) {
    this.editDiagramDialog = true;
    const payloadObj: any = {
      Id: 0,
      ContextQue: item.context,
      ImageCode: item.image
    };
    this.editImgPayload = payloadObj;
    this.editImgIndex = index;
  }


  editImage() {
    console.log(this.imageQuestions);
    console.log(this.editImgIndex);
    if (!this.diagramDescription || this.diagramDescription.trim() === '') {
      this.showErrorDialog("Please enter a description before edit image.");
      return;
    }
    this.isLoading = true;

    const selectedLangObj = this.questionLanguage.find(lang => lang.id === this.selectedLanguage);
    const payload = {
      image: this.editImgPayload.ImageCode,
      editType: this.diagramDescription,
      lang: selectedLangObj ? selectedLangObj.name : null
    };

    this.dataAnalyticsService.editImages(payload).subscribe(
      (response: any) => {
        console.log(response);

        const svgPattern = /<svg[\s\S]*<\/svg>/;
        const match = response.editedImage && response.editedImage.match(svgPattern);

        if (match) {
          this.editedImage = match[0];

          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Image changed successfully",
          });
        } else {
          // No SVG found — show error dialog
          this.showErrorDialog(
            response.editedImage || "Unexpected response. Please try again."
          );
        }

        this.isLoading = false;
      },
      error => {
        console.log("editImages error", error);
        this.messageService.add({
          severity: "error",
          summary: "Talkative Parents",
          detail: "Image editing failed",
        });

        this.showErrorDialog("Image editing failed due to server error.");
        this.isLoading = false;
      }
    );
  }


  confirmImage() {
    if (
      this.imageQuestions &&
      this.editImgIndex != null &&
      this.editImgIndex >= 0 &&
      this.editImgIndex < this.imageQuestions.length
    ) {
      this.imageQuestions[this.editImgIndex].image = this.editedImage;

      this.messageService.add({
        severity: "success",
        summary: "Image Updated",
        detail: "The edited image has been saved successfully.",
      });

      this.editDiagramDialog = false; // Close the popup if needed
    } else {
      this.showErrorDialog("Could not confirm image update. Invalid image index or data.");
    }
  }

}





// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/questions-generator/questions-generator.component.ts